export const interfaceTranslations = {
    selectedCountryAriaLabel: Lang.get('core.selected_country_aria_label'),
    noCountrySelected: Lang.get('core.no_country_selected'),
    countryListAriaLabel: Lang.get('core.country_list_aria_label'),
    searchPlaceholder: Lang.get('general.search'),
    zeroSearchResults: Lang.get('core.zero_search_results'),
    oneSearchResult: Lang.get('core.one_search_result'),
    multipleSearchResults: Lang.get('core.multiple_search_results'),
};
